import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

export const paymentDetailsSchema = z.object({
  isPaid: z.boolean().default(false),
  expirationDate: z.string().datetime().optional(),
  downloadCount: z.number(),
});

export class paymentDetailsDto extends createZodDto(paymentDetailsSchema) {}
